import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { Combo2Service, HyattEvent } from "../../../services/index";
import { JGRNService } from "../../../services/jgrn.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { jgrnBarcodePrint } from "../jobworkorder/jgrnbarcodeprint";
declare var google;

@Component({
  selector: "JGRN",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./JGRN.html",
})
export class JGRNComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  design_no: any;
  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    party_name: "",
    jgrn_from_date: "",
    jgrn_to_date: "",
    finyear: "",
    fab_design: "",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "jgrn_id",
    orderDir: "desc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("printTemplate") printTemplate: TemplateRef<any>;
  @ViewChild("codeTemplate") codeTemplate: TemplateRef<any>;

  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  data: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  jgrnList: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private jgrn: JGRNService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    public toasterService: ToasterService,
    private modalService: BsModalService,
    public event: HyattEvent
  ) {
    this.event.jgrnSaved$.subscribe((val: any) => {
      this.getJGRNList();
    });
  }
  ngOnInit(): void {
    this.getColumns();
    this.finyearCombo();
    this.toggleCol = Object.assign({}, this.columns);
    this.data = {
      jgrnList: [],
    };
  }

  hotkeys(event) {
    if (this.active) {
    }
  }
  getColumns() {
    this.columns = [
      {
        name: "S.No",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Party Name",
        prop: "party_name",
        cellClass: "text-left",
        headerClass: "text-center",
        minWidth: 160,
        maxWidth: 160,
        width: 160,
      },
      {
        name: "JGRN Date",
        prop: "jgrn_date_formatted",
        headerClass: "text-center",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
      },
      {
        name: "Inv No",
        prop: "inv_no",
        cellClass: "text-right",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      /*  { name: 'JGRN No', prop: 'ref_no', cellClass: 'text-right', headerClass: 'text-center', minWidth: 80, maxWidth: 80, width: 80 }, */
      {
        name: "Action",
        prop: "sno",
        minWidth: 100,
        maxWidth: 100,
        headerClass: "text-center",
        width: 100,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      },
      {
        name: "BARCODE",
        prop: "sno",
        minWidth: 100,
        maxWidth: 100,
        headerClass: "text-center",
        width: 100,
        sortable: false,
        cellTemplate: this.codeTemplate,
      },
      {
        name: "ADD WORKORDER",
        prop: "sno",
        minWidth: 120,
        maxWidth: 120,
        headerClass: "text-center",
        width: 120,
        sortable: false,
        cellTemplate: this.printTemplate,
      },
      {
        name: "Wo No",
        prop: "wo_no",
        cellClass: "text-right",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "JobDc No",
        prop: "dc_no",
        cellClass: "text-right",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
   
    ];
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_name").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;

  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.party_name = "";
    this.filter.jgrn_from_date = "";
    this.filter.jgrn_to_date = "";
    this.filter.fab_design = "";
    this.applyFilter();
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.filter.finyear = res.data[0].finyear;
      that.getJGRNList();
    });
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getJGRNList();
  }

  AddEditJGRN(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getJGRNList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD JGRN",
          title: "ADD JGRN",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "AddEditJGRN",
        },
      };
    } else if (mode == "Edit") {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "EDIT JGRN",
          title: "EDIT JGRN",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "AddEditJGRN",
        },
      };
    }
    else if (mode == "View") {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "VIEW JGRN",
          title: "VIEW JGRN",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "AddEditJGRN",
        },
      };

    }
    else if (mode == "WorkOrder") {
    tabObj = {
    action: "NewTab",
    params: {
      //  tabParent: 'Transaction',
      tabName: "ADD JOBESTIMATE WORK ORDER",
      title: "ADD JOBESTIMATE WORK ORDER",
      tabParent: "PURCHASE",
      mode: mode,
      data: row,
      name: "ADD JOBESTIMATE WORK ORDER",
    },
  };

    }
    this.tabUpdateEvent.emit(tabObj);
  }

  getJGRNList(): void {
    if (this.filter.jgrn_from_date == "") {
      this.filter.jgrn_from_date == "";
    } else {
      this.filter.jgrn_from_date = this.datePipe.transform(
        this.filter.jgrn_from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filter.jgrn_to_date == "") {
      this.filter.jgrn_to_date == "";
    } else {
      this.filter.jgrn_to_date = this.datePipe.transform(
        this.filter.jgrn_to_date,
        "yyyy-MM-dd"
      );
    }
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      party_name: this.filter.party_name,
      jgrn_from_date: this.filter.jgrn_from_date,
      jgrn_to_date: this.filter.jgrn_to_date,
      finyear: this.filter.finyear,
      fab_design: this.filter.fab_design,
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.jgrn.getjobJGrnList(params).then(function (res: any) {
      that.loadingIndicator = false;
      that.page.count = res.totCnt;
      that.jgrnList = res.data;
    });
  }
  // loadeditJGRNList(row) {
  //   let jgrn_id = row.jgrn_id;
  //   let params = {
  //     jgrn_id: jgrn_id,
  //   };
  //   this.jgrn.getEditJGRNList(params).then((res: any) => {
  //     this.data.jgrnList = res.data;
  //     // this.calcTotal();
  //     // this.calcQty();
  //     this.clickPrint(row, res.data);
  //   });
  // }
  bsModalRef: BsModalRef;
  printDet(row) {
    this.bsModalRef = this.modalService.show(jgrnBarcodePrint, {
      keyboard: false,
      ignoreBackdropClick: true,
      class: "modal-lg compWidth-96"
    });
    this.bsModalRef.content.printdt = Object.assign({}, row);
  }
  loadeditJGRNPrintList(rows) {
    let jgrn_id = rows.jgrn_id;
    let params = {
      jgrn_id: jgrn_id,
    };
    let that = this;
    that.jgrn.getEditJGRNList(params).then((res: any) => {
      that.data.jgrnList = res.data;
      var row = res.data[0];
      // that.calcTotal();
      // that.calcQty();
      if (row.jgrnType == 'BIT') {
        swal({
          title: "Please ensure that Small Sticker roll (Bit Roll) was inserted...",
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "Ok"
        }).then(() => {
          that.clickPrint(row, res.data);
        });
      } else {
        swal({
          title: "Please ensure that large Sticker roll (Bulk Roll) was inserted...",
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "Ok"
        }).then(() => {
          that.clickPrint(row, res.data);
        });
      }

    });
  }
  clickPrint(row, data) {
    let that = this;
    let params: any = Object.assign({}, row);
    params["data"] = JSON.stringify(data);
    that.isLoadMask = that.jgrn.jgrnprint(params).then(function (res: any) { });
  }

  deleteJGrn(row: any): void {
    let that = this;
    row["tabevent"] = undefined;
    swal({
      title: "Are you sure to delete this JGrn Details?",
      text:
        "You will not be able to recover this JGrn" + " " + row["ref_no"] + "",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.jgrn.deleteJGrn(row).then(function (res: any) {
          that.loadingIndicator = false;
          that.getJGRNList();
          let errtype = "success",
            errmsg = res.message;
          if (!res.success) {
            errtype = "error";
          }

          that.toasterService.pop({
            bodyOutputType: 1,
            type: errtype,
            title: errtype.toUpperCase(),
            body: errmsg,
          });
        });
      },
      function (dismiss) { }
    );
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/jgrn/JGRN.ts